
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 16.452c.894 0 1.625-.728 1.625-1.619 0-.89-.731-1.619-1.625-1.619s-1.625.729-1.625 1.619c0 .891.731 1.619 1.625 1.619zm4.875-7.285h-.813V7.548A4.056 4.056 0 0012 3.5a4.057 4.057 0 00-4.063 4.048v1.619h-.812c-.894 0-1.625.728-1.625 1.619v8.095c0 .89.731 1.619 1.625 1.619h9.75c.894 0 1.625-.729 1.625-1.619v-8.095c0-.891-.731-1.619-1.625-1.619zM9.481 7.548c0-1.385 1.13-2.51 2.519-2.51a2.517 2.517 0 012.519 2.51v1.619H9.481V7.548zm7.394 11.333h-9.75v-8.095h9.75v8.095z","fill-rule":"nonzero"}})])
          )
        }
      }
    